import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { useContext } from 'react'
import { inputContext } from '../../../../../context/inputsContext'
import { dateChecker } from '../../../../../helpers/dateChecker'

type Props = {
  start?: boolean
}

const DayPicker = ({ start }: Props) => {
  const { values, setValues } = useContext(inputContext)

  return (
    <Box p={1}>
      <Paper>
        <DesktopDatePicker
          disableFuture
          value={start ? values.startDate : values.endDate}
          minDate={new Date('2022-01-01')}
          onChange={(newValue) => {
            if (!newValue) return
            console.log(newValue)
            const dates = dateChecker({
              endDate: start
                ? values.endDate
                : Date.UTC(
                    newValue.getUTCFullYear(),
                    newValue.getUTCMonth(),
                    newValue.getUTCDate(),
                  ),
              startDate: start
                ? Date.UTC(
                    newValue.getUTCFullYear(),
                    newValue.getUTCMonth(),
                    newValue.getUTCDate(),
                  )
                : values.startDate,
            })
            setValues((c) => {
              return { ...c, ...dates }
            })
          }}
          inputFormat="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{
                ...params.inputProps,
                placeholder: 'dd/mm/yyyy',
              }}
            />
          )}
        />
      </Paper>
    </Box>
  )
}

export default DayPicker
